import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import Modal from 'react-bootstrap-modal';

import {LocalizedLink} from 'components/ReactRouterDomLocalized';

import ProfileLink from 'components/ProfileLink';

import {formatDate} from 'utils/memberPhotos';
import {getPaymentUrl} from 'utils/url';

import '../../sass/modals/modalShowPhotoComments.scss';

import {t, dt} from 'l10n';
import {ALBUM_CERTIFIED, ALBUM_PUBLIC} from '../../constants/memberPhoto';
import {getReturnPath} from '../../utils/url';

class ModalShowPhotoComments extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showComment: false
        };

        this.openPrevNextPhoto = this.openPrevNextPhoto.bind(this);
        this.onContentImgClick = this.onContentImgClick.bind(this);
    }
    
    onContextMenu(event) {
        event.preventDefault();
        return false;
    }

    openPrevNextPhoto(event, photo) {
        event.stopPropagation();
        this.props.openMemberPhoto(photo);
    }

    onContentImgClick(event) {
        if (event.target === this.contentImg) {
            this.props.closeFn();
        }
    }

    render() {
        // todo: fix modal width (it is correct only with comments shown)
        // todo: slider fn's

        let {show, currentUser, location, closeFn} = this.props;
        let {showComment} = this.state;

        if (!show) return null;

        let {memberPhoto, list} = this.props.memberPhoto;
        let currentIndex, prevMemberPhoto, nextMemberPhoto;
        if (list) currentIndex = list.findIndex((item) => item.id === memberPhoto.id);
        if (typeof currentIndex != 'undefined') {
            prevMemberPhoto = list[currentIndex-1];
            nextMemberPhoto = list[currentIndex+1];
        }

        let imgElement = null,
             noXXLBlock = null;

        if (
            currentUser.id === memberPhoto.user.id ||
            currentUser.isXXL() ||
            (currentUser.isLoggedIn() && memberPhoto.type === ALBUM_CERTIFIED) ||
            (currentUser.isLoggedIn() && !currentUser.isXXL() && memberPhoto.type === ALBUM_PUBLIC)
        ) {
            imgElement = <img src={memberPhoto.photo_url} onContextMenu={this.onContextMenu} alt="" />;
            noXXLBlock = null;
        } else if (!currentUser.isLoggedIn()) {
            imgElement = <img src={memberPhoto.thumb_url} alt="" className="bg-photo blur" onContextMenu={this.onContextMenu} />;
            noXXLBlock = (
            <div className="content-no-xxl-member">
                <img src={memberPhoto.thumb_url} alt="" onContextMenu={this.onContextMenu} />
                <div className="text">
                    <p>{dt('member_photo', 'Log in')}</p>
                    <p>{dt('member_photo', 'to open this photo.')}</p>

                    <Link
                        className="login-button"
                        to={{pathname: location.pathname, search: '?login&return_path='+encodeURIComponent(getReturnPath({hashBang: false}))}}
                        onClick={closeFn}
                    >{t('Log in')}</Link>
                </div>
            </div>
            );
        } else if (!currentUser.isXXL()) {
            imgElement = <img src={memberPhoto.thumb_url} alt="" className="bg-photo blur" onContextMenu={this.onContextMenu} />;
            noXXLBlock = (
            <div className="content-no-xxl-member">
                <img src={memberPhoto.thumb_url} alt="" onContextMenu={this.onContextMenu} />
                <div className="text">
                    <p dangerouslySetInnerHTML={{__html: dt('member_photo', 'You must be an <span>XXL</span> member')}}/>
                    <p>{dt('member_photo', 'to open this photo.')}</p>
                </div>
                <LocalizedLink to={getPaymentUrl(getReturnPath())} className="get-xxl-button" onClick={closeFn}>{dt('member_photo', 'Become an XXL member')}</LocalizedLink>
            </div>
            );
        }

        let commentsBlock = (<div className={(showComment) ? "comments on" : "comments"} onClick={()=>this.setState({showComment: false})}>
            <div className="top-content-comments">
                <div className="top-button">
                    <div>Hide info & comments</div>
                </div>
            </div>
            <div className="content-comments">
                <div>
                    <div className="top-info-comments">
                        <div>
                            <p className="username">bobweb1</p>
                            <p>20.12.2016 at 20:34</p>
                        </div>
                        {memberPhoto.like_count &&
                            <div>
                                <div className="likes">
                                    <span className="icon"></span> Like (6)
                                </div>
                            </div>
                        }
                    </div>

                    {memberPhoto.comments_ &&
                        <div className="text-info-comments">
                            <p className="name-info-message">Une nuit avec Brooke</p>

                            <p>Une nuit chaude passée avec Brooke. Venez voir la suite sur notre <br/> site. http://brookeremy.youmebob.com</p>

                            <div className="list-comments">
                                <p className="name-list-cmments">Commentaires <span>3</span></p>
                                <div className="items-list-comments">
                                    {memberPhoto.comments_.map((comment, index) =>
                                        <CommentItem comment={comment} key={index}/>
                                    )}
                                </div>
                            </div>

                            <div className="form-message">
                                <div className="form-avatar">
                                    <img src="/images/content/face.jpg" alt=""/>
                                </div>
                                <div className="form">
                                    <p>Envoyez votre commentaire</p>
                                    <form>
                                        <textarea></textarea>
                                        <input type="submit" value="Send"/>
                                    </form>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>);

        return (
            <Modal className="modalShowPhotoCmments" show={show} onHide={closeFn}
                   onExited={() => this.setState({showComment: false})}>
                <Modal.Body onClick={closeFn}>
                    <div className="close" onClick={closeFn}></div>
                    <div className="content-img" onClick={this.onContentImgClick} ref={(ref) => this.contentImg = ref}>
                        {imgElement}
                        {noXXLBlock}
                        <div className="info-user">
                            <div>
                                <div className="avatar-info-user">
                                    <img src={memberPhoto.user.avatar_url} alt=""/>
                                    <div className={memberPhoto.user.online ? 'status active' : 'status'}></div>
                                </div>
                                <div className="text-info-user">
                                    <ProfileLink user={memberPhoto.user} className="username" onClick={closeFn}/>
                                    <p>{formatDate(memberPhoto)}</p>
                                </div>
                            </div>
                        </div>

                        {/*
                        <div className={(showComment) ? 'button-bt' : 'button-bt on'} onClick={() => this.setState({showComment: true})}>
                            <div>
                                <p>Show info & comments</p>
                            </div>
                        </div>
                        */}

                        {memberPhoto.comments &&
                            <div className="photo-comments">
                                <div>
                                    <p>{memberPhoto.comments}</p>
                                </div>
                            </div>
                        }

                        {commentsBlock}
                    </div>
                    {prevMemberPhoto && <div className="left-slider" onClick={(e) => this.openPrevNextPhoto(e, prevMemberPhoto)}/>}
                    {nextMemberPhoto && <div className="right-slider" onClick={(e) => this.openPrevNextPhoto(e, nextMemberPhoto)}/>}
                </Modal.Body>
            </Modal>
        )
    }
}

function CommentItem() {
    return (
        <div className="item-list-comments">
            <div className="item-list-avatar">
                <img src="/images/content/face.jpg" alt=""/>
                <div className="status active"></div>
            </div>
            <div className="item-list-text">
                <div className="info-message">
                    <div>{/* <img src="/images/icons/message/1.png" alt="" /> */}</div>
                    <p>Luke Skywalker</p>
                    <div className="date">10/20/2013 at 13:47</div>
                </div>
                <div className="text-message">moi aussi je voudrais la meme tasse..à quand sur le bobstore???</div>
            </div>
        </div>
    )
}

export default ModalShowPhotoComments;


// WEBPACK FOOTER //
// ./src/components/modals/ModalShowPhotoComments.js